"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
var EventType;
(function (EventType) {
    EventType["ACCOUNT_PAGE_READY"] = "AccountPageReadyEvent";
    EventType["JOURNEY_STEP_CHANGED_EVENT"] = "JourneyStepChangedEvent";
})(EventType = exports.EventType || (exports.EventType = {}));
